import DropdownFilters from "../../../components/dropdown-filters/dropdown-filters";
import Header from "../../../components/header/header";
import SavedViewsControl from "../../../components/saved-views-control/saved-views-control";

const AuditAnalyticsHeader = ({
  title,
  filterItems,
  updateFilterValue,
  header,
  filters,
  savedViews,
  sortingOptions = [],
}) => {

  const savedViewsNode = (
    <SavedViewsControl
      projectId={savedViews.projectId}
      scope={savedViews.scope}
      filters={savedViews.filters}
      sorting={savedViews.sorting}
      defaultFilters={savedViews.defaultFilters}
      defaultSorting={savedViews.defaultSorting}
      filterItems={filterItems}
      sortingOptions={sortingOptions}
      savedViews={savedViews.items}
      savedViewsLoading={savedViews.loading}
      selectedViewId={savedViews.selectedViewId}
      onSelectedViewChange={savedViews.onSelectedViewChange}
      onApplySavedView={savedViews.onApplySavedView}
      onResetFilters={savedViews.onResetFilters}
      onReloadSavedViews={savedViews.onReloadSavedViews}
      disabled={savedViews.disabled}
    />
  );

  return (
    <Header
      title={title}
      search={header.search}
      stackedFilters={
        <div
          className="audit-analytics-filters-row"
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: 10,
            flexWrap: "wrap",
            width: "100%",
            minWidth: 0,
          }}
        >
          {savedViewsNode}
          <div className="audit-analytics-filters-col" style={{ flex: 1, minWidth: 0 }}>
            <DropdownFilters
              filtersBy={filterItems}
              updateFilterValue={updateFilterValue}
              filter={filters}
              mode="controlled"
              savedViewsMode
            />
          </div>
        </div>
      }
    />
  )
};

export default AuditAnalyticsHeader;